module.exports = __webpack_public_path__ + "static/media/chart_defensiv.e28a6009.svg";